import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1202Model } from './kymw1202.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { EventArgs } from '@grapecity/wijmo';
import { GetPublishMediumInfo } from './api-services/get-publish-medium-info.service';
import { UpdatePublishMediumSetting } from './api-services/update-publish-medium-setting.service';
import { KYMW1202InputModel } from './vo/kymw1202-input.model';
import { KYMW1202OutputModel } from './vo/kymw1202-output.model';

/**
 * 掲載媒体設定を管理するクラス
 *
 * @export KYMW1202Component
 * @class KYMW1202Component
 */
@Component({
  selector: 'app-kymw1202',
  templateUrl: 'kymw1202.component.html',
  styleUrls: ['kymw1202.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1202Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  @ViewChild('dtg_List', { static: false }) dtg_List: FlexGrid;
  @ViewChild('btn_Set', { static: false }) btn_Set: ElementRef;
  @ViewChild('chk_Header', { static: false }) chk_Header: ElementRef;

  public model: KYMW1202Model = new KYMW1202Model();
  private _procDone = false;

  /**
   * Creates an instance of KYMW1202Component.
   *
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetPublishMediumInfo} getPublishMediumInfo
   * @param {UpdatePublishMediumSetting} updatePublishMediumSetting
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1202Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getPublishMediumInfo: GetPublishMediumInfo,
    private updatePublishMediumSetting: UpdatePublishMediumSetting,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW1202Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1202';

    this.getPublishMediumInfo.execute(this.model);
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW1202Component
   */
  public ngAfterViewInit(): void {
    if (this.btn_Set) this.btn_Set.nativeElement.focus();
    this.dtg_List.itemsSourceChanged.addHandler(
      (_g: FlexGrid, _e: EventArgs) => {
        _g.select(-1, -1);
      }
    );
    this.dtg_List.hostElement.addEventListener('click', e => {
      const ht = this.dtg_List.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell && ht.col === 0) {
        const val = this.dtg_List.getCellData(ht.row, ht.col, false);
        this.dtg_List.setCellData(ht.row, ht.col, val ? false : true);
      }
      if (ht.cellType === CellType.ColumnHeader && ht.col === 0) {
        this.chk_Header.nativeElement.click();
      }
    });
  }

  /**
   * ボタン押下 設定
   *
   *
   * @memberof KYMW1202Component
   */
  public set() {
    const setReq = () => {
      this.updatePublishMediumSetting.execute(this.model, () => {
        this._procDone = true;
        this.closeFunction();
      });
    };

    // 媒体の選択がないかつ選択解除がある場合
    if (this.model.list.every(_ => !_.check) && this.model.hasCanceledMedium) {
      //媒体の選択がない場合
      this.dialogService.openAlertGetMessage('Q0160', ['媒体'], e => {
        if (e === PlessAlert.Yes) {
          //選択解除がある場合
          this.dialogService.openAlertGetMessage('Q0161', [], e => {
            if (e === PlessAlert.Yes) {
              setReq();
            }
          });
        }
      });
    } else if (this.model.list.every(_ => !_.check)) {
      //媒体の選択がない場合
      this.dialogService.openAlertGetMessage('Q0160', ['媒体'], e => {
        if (e === PlessAlert.Yes) {
          setReq();
        }
      });
    } else if (this.model.hasCanceledMedium) {
      //選択解除がある場合
      this.dialogService.openAlertGetMessage('Q0161', [], e => {
        if (e === PlessAlert.Yes) {
          setReq();
        }
      });
    } else {
      setReq();
    }
  }

  /**
   * ヘッダーチェックボックス入力
   *
   */
  public headerCheck() {
    const val = this.chk_Header.nativeElement.checked ?? false;
    this.model.list.forEach(_ => (_.check = val));
  }

  /**
   * ボタン押下 ×ボタン
   *
   */
  public closeModal() {
    if (this.model.hasChangedMedium) {
      this.dialogService.openAlertGetMessage('Q0174', [], e => {
        if (e === PlessAlert.Yes) {
          this.onClickClose();
        }
      });
    } else {
      this.onClickClose();
    }
  }

  /**
   * パラメータ格納 呼び出し側から利用
   *
   */
  public setParams(data: KYMW1202InputModel) {
    this.model.pCode = data.pCode;
  }

  /**
   * パラメータ取得 呼び出し側から利用
   *
   */
  public getParams(): KYMW1202OutputModel {
    return { procDone: this._procDone };
  }
}
